import classNames from 'classnames';
import * as React from 'react';
import { WidgetWrapper } from 'uxp/components';
import { IUIPropertyDefinition, IUIPropertyDefinitionMap, IWDDesignModeProps } from '../common';
import { SelectableItem, selectUIProps, selectUIPropsForMobileTempaltes } from '../SelectableItem';
import { ContainerProperty, extractContainerProperties } from '../ui-props/ContainerProperty';
import { extractTextProperties, TextProperty } from "../ui-props/TextProperty";
import './WidgetWrapperWithSidebar.scss';
import { BooleanProperty } from '../ui-props/BooleanProperty';
import { Conditional } from '../ConditionalComponent';
import { IContextData } from '../../../hooks/useContextData';
import { convertColor, convertColorStyles, hasValue, replaceWithData } from '../../../util';
export function createDefaultPropsForWidgetWrapperWithSidebar(props: any, enableHideHeader?: boolean): IUIPropertyDefinitionMap {
    let dp = props || {};

    let xprProps: any = {
        "headerContainer": ContainerProperty({
            background: {
                color: "",
                image: {
                    image: "",
                    position: "",
                    size: "",
                },
            },
        }, 'Title Section'),
        'title': TextProperty({ text: '', color: '', size: '' }, 'Title')
    }

    if (enableHideHeader) {
        xprProps.removeHeader = BooleanProperty('Hide Header', false)
    }

    let containerProps = ContainerProperty({
        background: {
            color: '',
            image: {
                image: "",
                position: "",
                size: "",
            },
        },
        text: { color: '' },
        removeShadow: false,
    }, 'Background')

    return { ...xprProps, chartContainer: containerProps, ...dp }
}
export interface IWidgetWrapperWithSidebarProps {
    className: string;
    designer?: IWDDesignModeProps;
    contextData: IContextData;
    uiProps: any;
    propDef: IUIPropertyDefinitionMap;
    defaultTitle?: string;
    elementId?: string;
    headerActions?: React.ReactNode;
    filterSection?: () => React.ReactElement;
    containerRef?: any;
    extractOnlyContainerProps?: boolean,
    ignore?: string[],
    enableHideHeader?: boolean,
    showContainerPropsLast?: boolean
    isInnerField?: boolean;
    parentUIProps?: any,
    index?: number,
    showFilterWithoutFields?: boolean
}
export const WidgetWrapperWithSidebar: React.FunctionComponent<IWidgetWrapperWithSidebarProps> = (props) => {
    let { contextData, uiProps, propDef, extractOnlyContainerProps, ignore, enableHideHeader, showContainerPropsLast, index, headerActions } = props;
    const { styles: headerStyles } = extractContainerProperties(uiProps.headerContainer);
    let { text: title, styles: titleStyles } = extractTextProperties(uiProps.title, props.defaultTitle || 'Widget');
    title = replaceWithData(title, contextData)
    const { styles: chartContainerStyles } = extractContainerProperties(uiProps.chartContainer);

    let titleProps = ['headerContainer', 'title'];
    let bodyProps = extractBodyProps()

    let showFilters = true
    if (!props.designer || !(props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
        showFilters = uiProps?.filter?.fields?.length > 0
    }

    function extractBodyProps() {
        if (extractOnlyContainerProps) {
            if (enableHideHeader) return ['removeHeader', 'chartContainer']
            return ['chartContainer']
        }
        else {
            let _bodyProps = Object.keys(props.propDef).filter(x => titleProps.indexOf(x) < 0);
            if (ignore && ignore.length > 0) {
                _bodyProps = _bodyProps.filter((p) => (!ignore.includes(p)))
            }
            if (showContainerPropsLast) {
                let ind = _bodyProps.indexOf('chartContainer')
                if (ind != -1) {
                    _bodyProps.splice(ind, 1)
                    _bodyProps.push('chartContainer')
                }
            }

            return _bodyProps
        }
    }

    const parentUIProps = (!!props.parentUIProps) ? { ...props.parentUIProps } : { ...uiProps }

    function getElementId(container: string) {
        if (hasValue(props?.elementId)) return `${props?.elementId}-${container}`
        return null
    }
    return <WidgetWrapper
        className={classNames(
            props.className,
            'wd-widget-wrapper',
            {
                'no-shadow': !!(uiProps.chartContainer?.removeShadow),
                'no-header': !!(uiProps.removeHeader)
            }
        )}
    >
        <div
            className='container'
            style={convertColorStyles(chartContainerStyles, contextData, { backgroundColor: '{$.theme.primaryBGColor}' })}
            ref={props.containerRef}
        >
            <Conditional visible={!props?.isInnerField}>
                {!uiProps.removeHeader &&
                    <div className="header">
                        <SelectableItem
                            designer={props.designer}
                            props={selectUIPropsForMobileTempaltes(parentUIProps, propDef, index, {}, 'headerContainer', 'title')}
                            contextData={contextData}
                            elementId={getElementId('header')}
                        >
                            <div className="uxp-widget-title-bar uxp-drag-handler" style={convertColorStyles(headerStyles, contextData)}>
                                <div className="title-section" style={titleStyles}>
                                    <span className="title-icon"></span>
                                    <span className="txt">{title}</span>
                                </div>

                                <div className="action-section widget-designer-titlebar-action-section">


                                    {
                                        !!headerActions
                                            ? <div className="header-actions">{headerActions}</div>
                                            : null
                                    }
                                    {/*  render filters if any */}
                                    {
                                        (showFilters && props.filterSection) || (props.showFilterWithoutFields)
                                            ? props.filterSection()
                                            : null
                                    }
                                </div>
                            </div>
                        </SelectableItem>
                    </div>}
            </Conditional>
            <SelectableItem
                className='content'
                showAtRuntime={true}

                designer={props.designer}
                props={selectUIPropsForMobileTempaltes(parentUIProps, propDef, index, {}, ...(bodyProps))}
                elementId={getElementId('content')}
                contextData={contextData}
            >
                {props.children}
            </SelectableItem>

        </div>
    </WidgetWrapper>;

}